import store from "@/store/index";

export const WATCH_VIDEO_IDENTITY = "ML_WATCH_VIDEO";
export const WATCH_VIDEO_HISTORY = "WATCH_VIDEO_HISTORY";
export const LIMIT_TIMES = 100; // 免费观看次数

export function getCurrentTime() {
  let currentTimes = localStorage.getItem(WATCH_VIDEO_IDENTITY);
  if (currentTimes === null) {
    return 0;
  } else {
    return parseInt(currentTimes);
  }
}

export function incrementOnce() {
  if (store.getters["user/isVip"]) return;
  let currentTimes = getCurrentTime();
  currentTimes++;
  localStorage.setItem(WATCH_VIDEO_IDENTITY, currentTimes.toString());
}

export function isExceedTimes() {
  if (store.getters["user/isVip"]) {
    return false;
  }
  return getCurrentTime() >= LIMIT_TIMES;
}

export function setWatchVideoHistory(videoId) {
  let watchVideoHistory = localStorage.getItem(WATCH_VIDEO_HISTORY);
  if (watchVideoHistory === null) {
    watchVideoHistory = [];
  } else {
    watchVideoHistory = JSON.parse(watchVideoHistory);
  }
  if (!watchVideoHistory.includes(videoId)) {
    watchVideoHistory.push(videoId);
  }
  localStorage.setItem(WATCH_VIDEO_HISTORY, JSON.stringify(watchVideoHistory));
}

export function getWatchVideoHistory() {
  const watchHistory = localStorage.getItem(WATCH_VIDEO_HISTORY);
  if (watchHistory === null) {
    return [];
  }
  try {
    return JSON.parse(watchHistory);
  } catch (e) {
    return [];
  }
}

export function clearWatchVideoHistory() {
  localStorage.setItem(WATCH_VIDEO_HISTORY, JSON.stringify([]));
}
